import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckboxChecked = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20 894V106C20 52 52 20 106 20H894C948 20 980 52 980 106V894C980 948 948 980 894 980H106C50 980 20 948 20 894ZM98 908H902V92H98ZM218 751V249C218 217 237 198 269 198H731C763 198 782 217 782 249V751C782 783 763 802 731 802H269C236 802 218 783 218 751Z" })
});
export default SvgCheckboxChecked;
